import axios from 'axios';

const getApiBaseUrl = () => {
  const url = process.env.REACT_APP_API_URL || 'https://backend.hunarmandpunjab.org.pk';
  return url.endsWith('/api') ? url : `${url.replace(/\/$/, '')}/api`;
};
const API_BASE_URL = getApiBaseUrl();

export const applyForScholarship = async (formData) => {
  const response = await axios.post(`${API_BASE_URL}/scholarship/apply`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const checkScholarshipStatus = async (rollNumber) => {
  const response = await axios.get(`${API_BASE_URL}/scholarship/check/${rollNumber}`);
  return response.data;
};

export const searchStudentByCnic = async (cnic) => {
  const isLocal = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  const baseUrl = isLocal
    ? 'http://localhost:3001/api'
    : (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : 'https://backend.hunarmandpunjab.org.pk/api');
  const response = await axios.get(`${baseUrl}/cnic-search/${encodeURIComponent(cnic)}`);
  return response.data;
};